import React, { useState,useEffect } from "react";
import CallIcon from "@mui/icons-material/Call";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import SmartphoneIcon from "@mui/icons-material/Smartphone";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import "./EditCustomerProfileMobileView.css";
import CustomerProfileTopButtons from "../../CustomerProfileTopButtons/CustomerProfileTopButtons";
import axios from "axios";

function EditCustomerProfileMobileView() {
  const [isEdit, setIsEdit] = useState(false);
  const [orderSummary, setOrderSummary] = useState([]);
  const [originCountryResponse, setOriginCountryResponse] = useState([]);
  const [originStateResponse, setOriginStateResponse] = useState([]);
  const [originCityResponse, setOriginCityResponse] = useState([]);
  const baseAPI = process.env.REACT_APP_API_URL;

  const handleCustomerProfileEditMode = () => {
    setIsEdit(true);
  };

  const CancelEditMode = () => {
    setIsEdit(false);
  };
  const email = JSON.parse(localStorage.getItem("email"));

  useEffect(() => {
    const storedToken = JSON.parse(localStorage.getItem("accessToken"));

    if (storedToken) {
      axios
        .get(`${baseAPI}customerget/GetCustomerProfileInfo?email=` + email, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          if (response) {
            setOrderSummary(response.data.data[0]);
            setFirstItem(response.data.data[0]);

            getCountry();
            getState(response.data.data[0].cust_country);
            getCity(response.data.data[0].cust_state);

          } else {
            console.error(
              "Invalid token or expired session:",
              response.data.message
            );
            // Handle invalid token scenario
          }
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
          if (error.response) {
            console.error("Response Data:", error.response.data);
            console.error("Response Status:", error.response.status);
            console.error("Response Headers:", error.response.headers);
          }
        });
    } else {
      console.error("No token found, redirect to login or show error");
    }
  }, []);

  const [firstItem, setFirstItem] = useState({
    First_Name: "",
    Last_Name: "",
    Email: "",
    Mobile_No: "",
    alternate_number: "",
    cust_address: "",
    cust_pinCode: "",
    cust_city: "",
    cust_state: "",
    cust_country: "",
  });

  const handleSelectChangeOriginCountry = (event) => {
    // Handle the select input change and update the selected value
    firstItem.cust_country = event.target.value;
    getState(event.target.value);
  };

  function getCountry() {
    const storedToken = JSON.parse(localStorage.getItem("accessToken"));

    axios
      .get(`${baseAPI}adminget/GETCountry?countryID=0`, {
        headers: {
          Authorization: `Bearer ${storedToken}`,
        },
      })
      .then((response) => {
        setOriginCountryResponse(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching user detail:", error);
      });
  }

  function getState(country_id) {
    if (country_id != null && country_id != "0") {
      const storedToken = JSON.parse(localStorage.getItem("accessToken"));
      axios
        .get(`${baseAPI}adminget/GETState?stateID=0&countryID=` + country_id, {
          headers: {
            Authorization: "Bearer " + storedToken,
          },
        })
        .then((response) => {
          setOriginStateResponse(response.data.data);
        });
    }
  }

  function getCity(state_id) {
    if (state_id != null && state_id != "0") {
      const storedToken = JSON.parse(localStorage.getItem("accessToken"));
      axios
        .get(`${baseAPI}adminget/GETCity?cityID=0&stateID=` + state_id, {
          headers: {
            Authorization: "Bearer " + storedToken,
          },
        })
        .then((response) => {
          setOriginCityResponse(response.data.data);
        });
    }
  }

  const handleChange1 = (e) => {
    const { name, value } = e.target;
    setFirstItem((prevItem) => ({
      ...prevItem,
      [name]: value,
    }));
  };

  const handleSelectChangeOriginState = (event) => {
    // Handle the select input change and update the selected value
    firstItem.cust_state = event.target.value;
    getCity(event.target.value);
  };

  const saveDetails = async (e) => {
    e.preventDefault();

    try {
      const storedToken = JSON.parse(localStorage.getItem("accessToken"));
      // Make a POST request to your API endpoint

      const response = await axios.post(
        `${baseAPI}customerpost/UpdateCustomerProfile`,
        firstItem, // Send firstItem as the request body
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );
      window.location.reload();
    } catch (error) {
      console.error("Error posting data:", error);
    }
  };

  return (
    <div>
      <div className="customer-edit-main px-1 py-3">
        <div className="row container-fluid p-0">
          <div className="col-12 px-3 customer-edit-img-div d-flex justify-content-start align-items-center">
            <div className="customer-icon">
              <PersonOutlineIcon className="" />
            </div>
            <div className="customer-edit-img-div-content">
              <h5>{orderSummary.First_Name} {orderSummary.Last_Name}</h5>
              <h6>{orderSummary.Email}</h6>
            </div>
          </div>
        </div>
        <div className="container-fluid px-2">
          <hr />
        </div>
        {isEdit ? (
          <form className="relocation-details-main-form">
            <div className="form-row row align-items-center">
              <div className="col-md-4 col-6">
                <label
                  style={{ color: "#6a6a6a", marginTop: "15px" }}
                  className=""
                  htmlFor=""
                >
                  First Name
                </label>
                <input
                  style={{
                    border: "1px solid #5B489D",

                    paddingLeft: "10px",
                    width: "100%",
                  }}
                  type="text"
                  className="form-control m-0"
                  placeholder="Enter"
                  name="First_Name"
                  value={firstItem.First_Name}
                  onChange={handleChange1}
                />
              </div>
              <div className="col-md-4 col-6">
                <label
                  style={{ color: "#6a6a6a", marginTop: "15px" }}
                  className=""
                  htmlFor=""
                >
                  Last Name
                </label>
                <input
                  style={{
                    border: "1px solid #5B489D",

                    paddingLeft: "10px",
                    width: "100%",
                  }}
                  type="text"
                  className="form-control m-0"
                  placeholder="Enter"
                  name="Last_Name"
                  value={firstItem.Last_Name}
                  onChange={handleChange1}
                />
              </div>
            </div>
            <div className="form-row row align-items-center">
              <div style={{ position: "relative" }} className="col-md-4 col-12">
                <label
                  style={{ color: "#6a6a6a", marginTop: "15px" }}
                  className=""
                  htmlFor=""
                >
                  Email ID
                </label>
                <input
                  style={{
                    border: "1px solid #5B489D",

                    paddingLeft: isEdit ? "29px" : "27px",
                    width: "100%",
                  }}
                  type="email"
                  className="form-control m-0"
                  placeholder="Enter"
                  value={firstItem.Email}
                  disabled
                />
                <MailOutlineIcon
                  style={{
                    fontSize: isEdit ? "22px" : undefined,
                    paddingLeft: "5px",
                    color: "#6a6a6a",
                    position: "absolute",
                    top: "45px",
                  }}
                />{" "}
              </div>
              <div style={{ position: "relative" }} className="col-md-4 col-6">
                <label
                  style={{ color: "#6a6a6a", marginTop: "15px" }}
                  className=""
                  htmlFor=""
                >
                  Contact Number
                </label>
                <input
                  style={{
                    border: "1px solid #5B489D",

                    paddingLeft: isEdit ? "29px" : "27px",
                    paddingTop: isEdit ? "5px" : "",
                    width: "100%",
                  }}
                  type="text"
                  className="form-control m-0"
                  placeholder="Enter"
                  name="Mobile_No"
                  value={firstItem.Mobile_No}
                  onChange={handleChange1}
                />
                <CallIcon
                  style={{
                    fontSize: isEdit ? "22px" : undefined,
                    paddingLeft: "5px",
                    color: "#6a6a6a",
                    position: "absolute",
                    top: "45px",
                  }}
                />
              </div>
              <div style={{ position: "relative" }} className="col-md-4 col-6">
                <label
                  style={{ color: "#6a6a6a", marginTop: "15px" }}
                  className=""
                  htmlFor=""
                >
                  Alternate Number
                </label>
                <input
                  style={{
                    border: "1px solid #5B489D",

                    paddingLeft: isEdit ? "29px" : "27px",
                    paddingTop: isEdit ? "5px" : "",
                    width: "100%",
                  }}
                  type="text"
                  className="form-control m-0"
                  placeholder="Enter"
                  name="alternate_number"
                  value={firstItem.alternate_number}
                  onChange={handleChange1}
                />
                <SmartphoneIcon
                  style={{
                    fontSize: isEdit ? "22px" : undefined,
                    paddingLeft: "5px",
                    color: "#6a6a6a",
                    position: "absolute",
                    top: "45px",
                  }}
                />
              </div>
            </div>
            <div className="form-row row align-items-center">
              <div className="col-md-4 col-12">
                <label
                  style={{ color: "#6a6a6a", marginTop: "15px" }}
                  className=""
                  htmlFor=""
                >
                  Address
                </label>
                <input
                  style={{
                    border: "1px solid #5B489D",

                    paddingLeft: "10px",
                    width: "100%",
                  }}
                  type="text"
                  className="form-control m-0"
                  placeholder="Enter"
                  name="cust_address"
                  value={firstItem.cust_address}
                  onChange={handleChange1}
                />
              </div>
              <div className="col-md-4 col-6">
                <label
                  style={{ color: "#6a6a6a", marginTop: "15px" }}
                  className=""
                  htmlFor=""
                >
                  Pin Code
                </label>
                <input
                  style={{
                    border: "1px solid #5B489D",

                    paddingLeft: "10px",
                    width: "100%",
                  }}
                  type="text"
                  className="form-control m-0"
                  placeholder="Enter"
                  name="cust_pinCode"
                  value={firstItem.cust_pinCode}
                  onChange={handleChange1}
                />
              </div>
              <div className="col-md-4 col-6">
                <label
                  style={{ color: "#6a6a6a", marginTop: "15px" }}
                  className=""
                  htmlFor=""
                >
                  City
                </label>
                <select
                  style={{
                    border: "1px solid #5B489D",

                    paddingLeft: "10px",
                    width: "100%",
                  }}
                  className="form-select m-0"
                  name="cust_city"
                  value={firstItem.cust_city}
                  onChange={handleChange1}
                >
                  <option value="">Select an option</option>
                  {originCityResponse.map((item) => (
                    <option value={item.id}>{item.name}</option>
                  ))}
                </select>
              </div>
            </div>

            <div className="form-row row align-items-center">
              <div className="col-md-4 col-6">
                <label
                  style={{ color: "#6a6a6a", marginTop: "15px" }}
                  className=""
                  htmlFor=""
                >
                  State
                </label>
                <select
                  style={{
                    border: "1px solid #5B489D",

                    paddingLeft: "10px",
                    width: "100%",
                  }}
                  className="form-select m-0"
                  name="cust_state"
                  onChange={handleSelectChangeOriginState}
                  value={firstItem.cust_state}
                >
                  <option value="">Select an option</option>
                  {originStateResponse.map((item) => (
                    <option value={item.state_id}>{item.stateName}</option>
                  ))}
                </select>
              </div>
              <div className="col-md-4 col-6">
                <label
                  style={{ color: "#6a6a6a", marginTop: "15px" }}
                  className=""
                  htmlFor=""
                >
                  Country
                </label>
                <select
                  style={{
                    border: "1px solid #5B489D",

                    paddingLeft: "10px",
                    width: "100%",
                  }}
                  className="form-select m-0"
                  name="cust_country"
                  onChange={handleSelectChangeOriginCountry}
                  value={firstItem.cust_country}
                >
                  <option value="">Select an option</option>
                  {originCountryResponse.map((item) => (
                    <option value={item.id}>{item.name}</option>
                  ))}
                </select>
              </div>
            </div>

            <hr style={{ marginTop: "46px" }} />
            <div
              style={{ textAlign: "end" }}
              className="customer-profile-bottom-button-div mt-4 px-4"
            >
              <button
                onClick={CancelEditMode}
                style={{
                  textAlign: "center",
                  fontSize: "14px",
                  color: "#F15843",
                  border: "none",
                }}
                type=""
                className="btn customer-profile-cancel-btn"
              >
                Cancel
              </button>
              <button
                style={{
                  color: "white",
                  fontSize: "14px",
                  backgroundColor: "#5B489D",
                }}
                type="submit"
                className="btn customer-profile-save-btn"
                onClick={saveDetails}
              >
                Save
              </button>
            </div>
          </form>
        ) : (
          <div className="relocation-details-main-form">
            <div className="form-row row align-items-start">
              <div className="col-md-4 col-6 p-0 text-start">
                <h4
                  style={{
                    fontSize: "14px",
                    color: "#6a6a6a",
                    marginTop: "15px",
                  }}
                >
                  First Name
                </h4>
                <h4
                  style={{
                    fontSize: "14px",
                    color: "#6a6a6a",
                    fontWeight: "700",
                  }}
                >
                  {orderSummary.First_Name}
                </h4>
              </div>
              <div className="col-md-4 col-6 p-0 text-start">
                <h4
                  style={{
                    fontSize: "14px",
                    color: "#6a6a6a",
                    marginTop: "15px",
                  }}
                >
                  Last Name
                </h4>
                <h4
                  style={{
                    fontSize: "14px",
                    color: "#6a6a6a",
                    fontWeight: "700",
                  }}
                >
                  {" "}
                  {orderSummary.Last_Name}
                </h4>
              </div>
            </div>

            <div className="form-row row align-items-start">
              <div className="col-md-4 col-12 p-0 text-start">
                <h4
                  style={{
                    fontSize: "14px",
                    color: "#6a6a6a",
                    marginTop: "15px",
                  }}
                >
                  Email ID
                </h4>
                <h4
                  style={{
                    fontSize: "14px",
                    color: "#6a6a6a",
                    fontWeight: "700",
                  }}
                >
                  {orderSummary.Email}
                </h4>
              </div>
            </div>

            <div className="form-row row align-items-start">
              <div className="col-md-4 col-6 p-0 text-start">
                <h4
                  style={{
                    fontSize: "14px",
                    color: "#6a6a6a",
                    marginTop: "15px",
                  }}
                >
                  Phone Number
                </h4>
                <h4
                  style={{
                    fontSize: "14px",
                    color: "#6a6a6a",
                    fontWeight: "700",
                  }}
                >
                  {orderSummary.Mobile_No}
                </h4>
              </div>
              <div className="col-md-4 col-6 p-0 text-start">
                <h4
                  style={{
                    fontSize: "14px",
                    color: "#6a6a6a",
                    marginTop: "15px",
                  }}
                >
                  Alternative Number
                </h4>
                <h4
                  style={{
                    fontSize: "14px",
                    color: "#6a6a6a",
                    fontWeight: "700",
                  }}
                >
                  {orderSummary.alternate_number}
                </h4>
              </div>
            </div>

            <div className="form-row row align-items-start">
              <div className="col-md-4 col-12 p-0 text-start">
                <h4
                  style={{
                    fontSize: "14px",
                    color: "#6a6a6a",
                    marginTop: "15px",
                  }}
                >
                  Address
                </h4>
                <h4
                  style={{
                    fontSize: "14px",
                    color: "#6a6a6a",
                    fontWeight: "700",
                    paddingRight: "20px",
                  }}
                >
                  {orderSummary.cust_address}
                </h4>
              </div>
            </div>

            <div className="form-row row align-items-start">
              <div className="col-md-4 col-6 p-0 text-start">
                <h4
                  style={{
                    fontSize: "14px",
                    color: "#6a6a6a",
                    marginTop: "15px",
                    paddingLeft: "2px",
                  }}
                >
                  Pin Code
                </h4>
                <h4
                  style={{
                    fontSize: "14px",
                    color: "#6a6a6a",
                    fontWeight: "700",
                  }}
                >
                  {orderSummary.cust_pinCode}
                </h4>
              </div>
              <div className="col-md-4 col-6 p-0 text-start">
                <h4
                  style={{
                    fontSize: "14px",
                    color: "#6a6a6a",
                    marginTop: "15px",
                  }}
                >
                  City
                </h4>
                <h4
                  style={{
                    fontSize: "14px",
                    color: "#6a6a6a",
                    fontWeight: "700",
                  }}
                >
                  {orderSummary.cust_city1}
                </h4>
              </div>
            </div>

            <div className="form-row row align-items-start">
              <div className="col-md-4 col-6 p-0 text-start">
                <h4
                  style={{
                    fontSize: "14px",
                    color: "#6a6a6a",
                    marginTop: "15px",
                  }}
                >
                  State
                </h4>
                <h4
                  style={{
                    fontSize: "14px",
                    color: "#6a6a6a",
                    fontWeight: "700",
                  }}
                >
                  {orderSummary.cust_state1}
                </h4>
              </div>
              <div className="col-md-4 col-6 p-0 text-start">
                <h4
                  style={{
                    fontSize: "14px",
                    color: "#6a6a6a",
                    marginTop: "15px",
                  }}
                >
                  Country
                </h4>
                <h4
                  style={{
                    fontSize: "14px",
                    color: "#6a6a6a",
                    fontWeight: "700",
                  }}
                >
                  {orderSummary.cust_country1}
                </h4>
              </div>
            </div>
            <div className="p-0 m-0">
              <hr style={{ width: "96%" }} />
            </div>
            <div className="col-12 text-end d-flex justify-content-end align-items-start">
              <div className="customer-profile-edit-button-div">
                <button
                  onClick={handleCustomerProfileEditMode}
                  style={{ fontSize: "14px" }}
                  type=""
                  className="btn px-4"
                >
                  Edit
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default EditCustomerProfileMobileView;
